import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../stores/auth';
import { timeAgo, formatUzs } from '../lib/format';

export function CustomerHomePage() {
  const auth = useAuth();
  const nav = useNavigate();
  const [search, setSearch] = useState('');

  const { data: orders } = useQuery({
    queryKey: ['my-orders'],
    queryFn: () => api.myOrders(),
  });

  const { data: bookings } = useQuery({
    queryKey: ['my-bookings'],
    queryFn: () => api.myBookings(),
  });

  const upcomingBookings = (bookings ?? []).filter(
    (b: any) => new Date(b.scheduledAt) > new Date() && b.status !== 'CANCELLED',
  );
  const activeOrders = (orders ?? []).filter(
    (o: any) => !['DELIVERED', 'CANCELLED'].includes(o.status),
  );

  return (
    <>
      <div className="card" style={{ background: 'linear-gradient(135deg, var(--primary), #1a6db3)', borderColor: 'transparent' }}>
        <div className="muted" style={{ color: 'rgba(255,255,255,0.7)' }}>Salom,</div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#fff' }}>
          {auth.user?.name ?? 'Mijoz'} 👋
        </div>
        <div className="muted" style={{ color: 'rgba(255,255,255,0.8)', marginTop: 4 }}>
          Avtomobilingiz uchun eng yaxshi xizmat
        </div>
      </div>

      <div className="field">
        <input
          placeholder="🔍 Servis qidirish (masalan: Moy almashtirish)"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && search.trim()) {
              nav(`/marketplace?q=${encodeURIComponent(search.trim())}`);
            }
          }}
        />
      </div>

      <div className="row" style={{ gap: 8, marginBottom: 14 }}>
        <Link to="/marketplace" className="btn btn-primary" style={{ flex: 1, textAlign: 'center' }}>
          🔍 Servis topish
        </Link>
        <Link to="/vehicle-passport" className="btn" style={{ flex: 1, textAlign: 'center' }}>
          📜 Passport
        </Link>
      </div>

      {upcomingBookings.length > 0 && (
        <>
          <h3>📅 Yaqin bandlar</h3>
          {upcomingBookings.slice(0, 3).map((b: any) => (
            <div key={b.id} className="card">
              <div className="row-between" style={{ marginBottom: 4 }}>
                <div style={{ fontWeight: 600 }}>{b.workshop.name}</div>
                <span className={`tag ${b.status === 'CONFIRMED' ? 'success' : 'warning'}`}>
                  {b.status}
                </span>
              </div>
              <div className="muted" style={{ fontSize: 13 }}>
                {b.service?.name ?? 'Xizmat'} · 🚗 {b.car?.plate ?? '—'}
              </div>
              <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>
                🕐 {new Date(b.scheduledAt).toLocaleString('uz-UZ')}
              </div>
            </div>
          ))}
          <Link to="/my-bookings" className="btn btn-block" style={{ marginTop: 4 }}>
            Hammasi →
          </Link>
        </>
      )}

      {activeOrders.length > 0 && (
        <>
          <h3>🔧 Faol buyurtmalar</h3>
          {activeOrders.slice(0, 3).map((o: any) => (
            <div key={o.id} className="card">
              <div className="row-between" style={{ marginBottom: 4 }}>
                <div style={{ fontWeight: 600 }}>{o.workshop.name}</div>
                <span className="tag primary">{o.status}</span>
              </div>
              <div className="muted" style={{ fontSize: 13 }}>
                🚗 {o.car.plate} · {o.car.brand} {o.car.model}
              </div>
              <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>
                {o.problem.length > 50 ? o.problem.slice(0, 50) + '…' : o.problem}
              </div>
              <div className="row-between" style={{ marginTop: 6 }}>
                <div className="muted" style={{ fontSize: 11 }}>{timeAgo(o.receivedAt)}</div>
                <div className="amount" style={{ fontWeight: 600 }}>{formatUzs(o.totalCached)}</div>
              </div>
            </div>
          ))}
          <Link to="/my-orders" className="btn btn-block" style={{ marginTop: 4 }}>
            Hammasi →
          </Link>
        </>
      )}

      {upcomingBookings.length === 0 && activeOrders.length === 0 && (
        <div className="empty">
          <div className="emoji">🚗</div>
          <div>Hozircha faol buyurtmalar yo'q</div>
          <div className="muted" style={{ marginBottom: 10 }}>Servis qidirib boshlang</div>
          <Link to="/marketplace" className="btn btn-primary">
            🔍 Servis topish
          </Link>
        </div>
      )}
    </>
  );
}
